// fullFormatVerseReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  historyList: [],
  historyListItemSelected: 0,
  historyBookChapter: { book: 0, chapter: 0 },
  title: '',
  titleClearButton: false,
};

const fullFormatVerseSlice = createSlice({
  name: 'fullFormatVerse',
  initialState,
  reducers: {
    setTitle(state, action) {
      state.title = action.payload;
    },
    setTitleClearButton(state, action) {
      state.titleClearButton = action.payload;
    },
    setHistoryListItemSelected(state, action) {
      state.historyListItemSelected = action.payload;
    },
    setHistoryBookChapter(state, action) {
      state.historyBookChapter = action.payload;
    },
    reset4Dialog2() {
      return initialState;
    },
  },
});

export const { setTitle, setTitleClearButton, setHistoryListItemSelected, setHistoryBookChapter, reset4Dialog2 } = fullFormatVerseSlice.actions;
export default fullFormatVerseSlice.reducer;
// const initialState = {
//   loading: false,
//   historyList: [],
//   historyListItemSelected: 0,
//   historyBookChapter: { book: 0, chapter: 0 },

//   title: '',
//   titleClearButton: false,
// };

// export default function fullFormatVerseReducer(state = initialState, action) {
//   switch (action.type) {
//     case 'setTitle':
//       return {
//         ...state,
//         title: action.payload,
//       };
//     case 'setTitleClearButton':
//       return {
//         ...state,
//         titleClearButton: action.payload,
//       };          
//     case 'setHistoryListItemSelected':
//       return {
//         ...state,
//         historyListItemSelected: action.payload,
//       };
//     case 'setHistoryBookChapter':
//       return {
//         ...state,
//         historyBookChapter: action.payload,
//       };
//     case 'reset4Dialog2':
//       return initialState;          
//     default:
//       return state;
//   }
// }

// export const setTitle = (e) => ({
//   type: 'setTitle',
//   payload: e,
// });

// export const setTitleClearButton = (e) => ({
//   type: 'setTitleClearButton',
//   payload: e,
// });

// export const setHistoryListItemSelected = (e) => ({
//   type: 'setHistoryListItemSelected',
//   payload: e,
// });

// export const setHistoryBookChapter = (e) => ({
//   type: 'setHistoryBookChapter',
//   payload: e,
// });

// export const reset4Dialog2  = (e) => ({
//   type: 'reset4Dialog2',
//   payload: e,
// });